export default __webpack_public_path__ + "static/media/img_banner.19aceb7f.jpg";